export const TENANT_STATUS = {
  ACTIVE: '1',
  BLOCKED: '2',
};

export const TENANT_STATUS_LABELS = {
  [TENANT_STATUS.ACTIVE]: 'Active',
  [TENANT_STATUS.BLOCKED]: 'Blocked',
};

/** Normalize API / legacy values to a status code ('1' | '2'). */
export const normalizeTenantStatus = (raw) => {
  if (raw == null || raw === '') return null;
  const s = String(raw).trim();
  if (Object.values(TENANT_STATUS).includes(s)) return s;

  const lower = s.toLowerCase();
  const byName = {
    active: TENANT_STATUS.ACTIVE,
    blocked: TENANT_STATUS.BLOCKED,
    inactive: TENANT_STATUS.BLOCKED,
  };
  return byName[lower] ?? null;
};

export const getTenantStatusLabel = (raw) => {
  const code = normalizeTenantStatus(raw);
  if (code) return TENANT_STATUS_LABELS[code];
  if (raw == null || raw === '') return '—';
  const s = String(raw).trim();
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

export const getTenantStatusBadgeVariant = (raw) => {
  const code = normalizeTenantStatus(raw);
  if (code === TENANT_STATUS.ACTIVE) return 'success';
  if (code === TENANT_STATUS.BLOCKED) return 'danger';
  const lower = String(raw ?? '').toLowerCase();
  if (lower === 'pending') return 'warning';
  return 'muted';
};
